import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import Table from '@tables/table'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { FormControl, InputLabel, Select, MenuItem, Grid, Button, Divider } from '@material-ui/core'
import Search from '@material-ui/icons/Search'
import { API, RISKMGT } from '@const'
import * as utils from '@utils'
import AddManualPrizeDialog from './add-manual-prize-dialog'
import ConfirmMsgDialog from '../msg-dialogs/confirm-msg-dialog'
import RefreshButton from '@miscs/refresh-button'
import DateSelect from '@select/date-from-to-select'

class ManualPrizeListDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'ManualPrizeListDialog')
        }
    }

    state = {
        pf_account: '',
        prizeList: {},
        oid: 'all',
        input: {},
        dialogOpen: false,
        isLoading: false,
        openFrom: '',
    }

    columns = [
        { field: 'created_at', type: 'datetime' },
        { field: 'pf_account' },
        {
            field: 'oid',
        },
        {
            field: 'game_name',
            translate: {
                dataKey: 'game_code',
                tranKey: 'GameName',
            },
        },
        {
            field: 'bet_range',
            render: (rowData) => '[' + rowData['bet_range'].join(', ') + ']',
        },
        {
            field: 'claim_prize',
        },
        {
            field: 'prize',
            type: 'currency',
        },
        {
            field: 'state_translated',
            translate: {
                dataKey: 'state',
                tranKey: 'Compensation',
            },
        },
        {
            field: 'updated_at',
            type: 'datetime',
        },
    ]

    componentDidMount() {
        this.queryPrizeList()
        this.columns.push({
            field: 'cancel_manual_prize',
            render: (rowData) => {
                return (
                    <Button
                        variant="contained"
                        style={{ minWidth: '72px' }}
                        onClick={() => {
                            this.confirmDialog.OpenDialog({
                                type: 'warn',
                                msg: this.t('confirmDeleteMsg'),
                                confirm: (_params) => {
                                    this.confirmDialog.SetConfirmBtnDisabled(true)

                                    utils.apiRequest(
                                        'delete',
                                        API.RISKMGT_COMPENSATION,
                                        { id: rowData.id },
                                        (_data) => {
                                            this.confirmDialog.closeDialog()
                                            this.queryData()
                                        },
                                        (_err) => {
                                            this.confirmDialog.SetConfirmBtnDisabled(false)
                                        }
                                    )
                                },
                            })
                        }}
                        color="primary"
                        disabled={rowData.state !== RISKMGT.COMPENSATION_STATE_PENDING}>
                        {this.t('cancel')}
                    </Button>
                )
            },
        })
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    reset(param) {
        this.setState({
            input: {},
            pf_account: param.pf_account,
            isLoading: false,
        })
    }

    OpenDialog(param) {
        this.reset(param)
        if (param.from === 'ManualPrizePage') {
            this.actions = []
        } else {
            this.actions = [
                {
                    text: '新增派獎',
                    icon: 'add',
                    isFreeAction: true,
                    onClick: (_evt, data) => {
                        this.addDialog.OpenDialog(data, true)
                    },
                },
            ]
        }
        this.setState({ dialogOpen: true, openFrom: param.from })
    }

    CloseDialog() {
        this.setState({ dialogOpen: false })
    }

    updateColumn = () => {}

    queryPrizeList = () => {
        utils.apiRequest(
            'get',
            API.RISKMGT_COMPENSATION_PRIZE_LIST,
            {},
            (data) => {
                if (data) {
                    const oid = Object.keys(data)[0]
                    this.setState({
                        prizeList: data,
                        input: {
                            ...this.state.input,
                            oid: oid,
                            claim_prize: Object.entries(data[oid].prize_list).sort(([_a_key, a], [_b_key, b]) =>
                                a[0].multiple_boundary[0] > b[0].multiple_boundary[0] ? 1 : -1
                            )[0][1][0].key,
                        },
                    })
                }
            },
            (_err) => {
                this.setState({ prizeList: {} })
            },
            true
        )
    }

    queryData = () => {
        this.table.queryData(
            this.state.pf_account
                ? { pf_account: this.state.pf_account }
                : {
                      during: [
                          utils.datetimeToUnix_startOf(this.dateSelect.state.startDate, 'day'),
                          utils.datetimeToUnix_endOf(this.dateSelect.state.endDate, 'day'),
                      ].join(','),
                      oid: this.state.oid === 'all' ? undefined : this.state.oid,
                  }
        )
    }

    render() {
        return (
            <Dialog open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })} scroll="body" fullWidth={true} maxWidth="xl">
                <DialogTitle>{this.state.openFrom === 'ManualPrizePage' ? this.t('Title2') : this.t('Title')}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        {!this.state.pf_account ? (
                            <React.Fragment>
                                <DateSelect onRef={(ref) => (this.dateSelect = ref)}></DateSelect>
                                <Grid item xs={1}>
                                    <FormControl className={this.props.classes.formControl} fullWidth>
                                        <InputLabel shrink>{this.t('oid')}</InputLabel>
                                        <Select
                                            value={this.state.oid}
                                            onChange={(event) =>
                                                this.setState({
                                                    oid: event.target.value,
                                                })
                                            }>
                                            <MenuItem value="all">{this.t('all')}</MenuItem>
                                            {Object.entries(this.state.prizeList).map(([key, elem]) => {
                                                return (
                                                    <MenuItem value={key} key={key}>
                                                        {key +
                                                            ': ' +
                                                            this.t('GameName.' + elem.game_code) +
                                                            ' (' +
                                                            this.t('RoomType.' + elem.room_type_code_id) +
                                                            ')'}
                                                    </MenuItem>
                                                )
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={1}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        className={this.props.classes.button}
                                        onClick={() => {
                                            this.setState({ isLoading: true })
                                            this.queryData()
                                        }}
                                        disabled={this.state.isLoading}>
                                        <Search className={this.props.classes.rightIcon} />
                                        {this.t('search')}
                                    </Button>
                                </Grid>
                            </React.Fragment>
                        ) : (
                            <Grid item xs={4}></Grid>
                        )}
                        <Grid item xs={7}></Grid>
                        <RefreshButton callback={() => this.queryData()}></RefreshButton>
                        <Grid item xs={12}>
                            <Table
                                ownerName="ManualPrizeListDialog"
                                columns={this.columns}
                                options={{
                                    export: true,
                                    // selection: true,
                                }}
                                actions={this.actions}
                                onRef={(ref) => (this.table = ref)}
                                queryDataArgs={{
                                    apiPath: API.RISKMGT_COMPENSATION_LIST,
                                    callback: () => {
                                        this.setState({ isLoading: false })
                                    },
                                }}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button variant="contained" onClick={() => this.setState({ dialogOpen: false })} color="primary">
                        {this.t('confirm')}
                    </Button>
                </DialogActions>
                <AddManualPrizeDialog
                    confirmCallback={() => {
                        this.queryData()
                    }}
                    onRef={(ref) => (this.addDialog = ref)}
                    ownerState={this.state}
                />
                <ConfirmMsgDialog onRef={(ref) => (this.confirmDialog = ref)} />
            </Dialog>
        )
    }
}

ManualPrizeListDialog.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string),
    onRef: PropTypes.func.isRequired,
}

const styles = (_theme) => ({})

export default hoc(styles)(ManualPrizeListDialog)
